import { keyGenerator } from '@ctn/ui/components/ctn-utils';

/** Si el objeto aún no tiene un id, se le asigna una id temporal */
export const getID = (id?: number, idReact?: string) => {
	const newIdReact = idReact ?? keyGenerator({ blocks: 5, lengthByBlock: [8, 8, 8, 8, 8] });
	return { id: id as number, idReact: id ? undefined : newIdReact };
};

/** 
 * Busca el índice de un elemento en la lista comparando por id o idReact (id temporal). 
 * Si no encuentra el index devolverá un -1
 */
export const findID = ({
	list,
	id: idCurrent,
	idReact: idReactCurrent,
}: {
	list: Array<{ id?: number; idReact?: string }>;
	id?: number;
	idReact?: string;
}) => list.findIndex(({ idReact = '0', id = 0 }) => idReact === idReactCurrent || id === idCurrent);
